var SaveCkycDetailsMapper = function (resp) {
    if (resp)
        return {
            StrMsg: resp.StrMsg,
            strContactLnk: resp.strContactLnk,
        };
    return {};
};
export default SaveCkycDetailsMapper;
